'use client';

import { usePathname } from 'next/navigation';

import styles from './PreviewLabel.module.scss';

export default function PreviewLabel() {
    const pathname = usePathname();
    return (
        <div className={styles.container}>
            <span className={styles.label}>
                preview mode
                <a className={styles.exitButton} href={`/api/exit-preview?path=${pathname}`}>
                    &times;
                </a>
            </span>
        </div>
    );
}
